<template>
  <!-- 活动 -->
  <div class="tab-page">
    <div class="head">
      <div class="searchcontain">
        <el-input v-model="queryParams.keyword" placeholder="搜索" suffix-icon="el-icon-search"
          style="font-size: 14px; width: 330px;" @change="handleSearch" class="searchInput"></el-input>
      </div>
    </div>
    <div class="main" v-loading="loading">
      <div class="goods_list" v-if="listData.length > 0">
        <div class="goods_item" v-for="(item, index) in listData" :key="index">
          <div class="goods_info" @click.stop="toDetail(item)">
            <el-image class="elimage" :src="item.cover ? item.cover : cover" @error="handleError"
              style="cursor: pointer" />
            <div class="elinfo">
              <div class="info-cont--top">
                <div class="top-info--box">
                  <div class="title ellipsis">{{ item.title }}</div>
                  <div class="status-box" :class="item.activity_status">
                    {{ item.activity_status_name }}
                  </div>
                </div>
                <div class="tag_box">
                  <span class="category_name ellipsis">{{ item.category_name }}</span>
                </div>
              </div>
              <div class="text">
                <div class="info-reason" v-if="item.status === 3">驳回原因: {{ item.reason || '-' }}</div>
                <div class="time">
                  <span class="tit">活动时间：</span>
                  <span class="txt">{{ item.start_time | dateFormat }} / {{ item.end_time | dateFormat }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="goods_handle">
            <div class="status" :class="`status${item.status}`">
              <i class="dot"></i>
              <span class="txt">{{ item.status | statusFormat }}</span>
            </div>
          </div>
        </div>
        <div class="elpagination">
          <div class="elpagination-title">共{{ total }}条</div>
          <el-pagination background layout="prev, pager, next, jumper" prev-text="上一页" next-text="下一页" :page-size="10"
            :total="total" :current-page="queryParams.page" @size-change="changeSize"
            @current-change="changePage"></el-pagination>
        </div>
      </div>
      <template v-else>
        <el-empty :image-size="110" class="el-empty--cont"></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import { getMyActivityList } from "@/api/activity"
import dayjs from "dayjs"
// 0：暂存，1：待审核，2：已通过，3：已驳回，4：审核中  5：审核撤销   6：自己撤销
const statusMap = {
  0: "草稿",     //暂存
  1: "已报名",   //待审核
  2: "已参加",   //已通过
  3: "报名失败", //已驳回
  6: "用户撤销"  // 自己撤销
}
export default {
  name: "MyActivity",
  components: {},
  filters: {
    dateFormat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY.MM.DD HH:mm:ss")
    },
    statusFormat(value) {
      return statusMap[value]
    },
  },
  data() {
    return {
      queryParams: {
        keyword: "",
        per_page: 10,
        page: 1,
      },
      total: 0,
      listData: [],
      loading: false,
      isDelete: false,
      cover: require("@/assets/default/image01.jpg"),
      datalist: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 我的学习情况列表
    getList() {
      this.loading = true
      getMyActivityList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.listData = res.data?.data ?? []
          this.total = res.data?.total ?? 0
        }
      }).catch(() => { })
    },
    // 分页-当页条数
    changeSize(data) {
      this.queryParams.per_page = data
      this.getList()
    },
    // 分页-当前页数
    changePage(data) {
      this.queryParams.page = data
      this.getList()
    },
    // 查询
    handleSearch(val) {
      this.queryParams.page = 1 // 搜索默认查询第一页
      this.listData = []
      this.total = 0
      this.getList()
    },
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.cover
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    // 进入详情页
    toDetail(item) {
      window.localStorage.setItem("menuId", 1)
      this.$store.dispatch("setmenuid", 1)
      this.$router.push({
        path: "/home/activity/detail",
        query: {
          id: item.id,
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.tab-page {
  padding: 30px;

  .head {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .head-title {
      font-size: 20px;
      font-weight: 400;
      color: #005cbb;
      user-select: none;
      white-space: nowrap;
    }
  }

  .main {
    // padding: 20px;
    background: #ffffff;
    box-sizing: border-box;

    .goods_list {
      .goods_item {
        width: 100%;
        display: flex;
        margin-top: 30px;
        padding-bottom: 30px;
        box-sizing: border-box;
        cursor: pointer;
        border-bottom: 1px solid #f7f7f7;

        .goods_info {
          width: calc(100% - 100px);
          display: flex;
          justify-content: flex-start;
          align-content: center;

          .elimage {
            width: 340px;
            min-width: 340px;
            height: 235px;
            border-radius: 5px;
          }

          .elinfo {
            width: calc(100% - 340px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 20px;
            box-sizing: border-box;

            .info-cont--top {
              .top-info--box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .title {
                  color: #222222;
                  font-size: 18px;
                  font-weight: 500;
                  max-width: calc(100% - 70px);
                  // line-height: 40px;
                }

                .status-box {
                  margin-left: 10px;
                  width: 60px;
                  height: 24px;
                  border-radius: 0px 12px 0px 12px;
                  font-size: 14px;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }

                .no_start {
                  background-color: rgba($color: #f94f17, $alpha: 0.1);
                  color: #f94f17;
                }

                .on_going {
                  background-color: rgba($color: #005cbb, $alpha: 0.1);
                  color: #005cbb;
                }

                .on_end {
                  background-color: rgba($color: #999999, $alpha: 0.1);
                  color: #999999;
                }
              }

              .tag_box {
                margin-top: 14px;

                .category_name {
                  display: inline-block;
                  width: 80px;
                  padding: 6px 10px;
                  border-radius: 5px;
                  background-color: #005cbb;
                  color: #fff;
                  font-size: 12px;
                  box-sizing: border-box;
                  text-align: center;
                }
              }
            }

            .text {
              color: #999999;
              font-size: 14px;
              font-weight: 400;

              .info-reason {
                margin-bottom: 10px;
                font-size: 16px;
                color: #666;
              }
            }
          }
        }

        .goods_handle {
          width: 100px;
          text-align: right;

          .status {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .dot {
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-right: 10px;
            }

            .txt {
              color: #333333;
              font-size: 18px;
              font-weight: 400;
              // line-height: 20px;
            }
          }

          .status0 {
            .dot {
              background: #999999;
            }
          }

          .status1,
          .status6 {
            .dot {
              background: #005cbb;
            }
          }

          .status2 {
            .dot {
              background: #4bb200;
            }
          }

          .status3 {
            .dot {
              background: #ff0000;
            }
          }
        }
      }
    }

    .el-empty--cont {
      padding: 0px;
      min-height: 400px;
    }
  }

  .elpagination {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .elpagination-title {
      margin-right: 4px;
    }
  }

  ::v-deep .el-progress-bar {
    margin-right: -70px;
  }

  ::v-deep .el-progress__text {
    float: right;
  }

  ::v-deep .searchInput {
    .el-input__inner {
      border-radius: 40px;
    }

    .el-input__suffix {
      font-size: 18px;
    }
  }
}

.btn-primary {
  color: #fff;
  background-color: #005cbb;
  border-color: #005cbb;
}

.btn-primary.is-plain {
  color: #005cbb;
  background: #fff;
  border-color: #005cbb;
}

.btn-danger {
  color: #fff;
  background-color: #ff0000;
  border-color: #ff0000;
}

.btn-danger.is-plain {
  color: #ff0000;
  background: #fff;
  border-color: #ff0000;
}

@media screen and (max-width: 640px) {
  .tab-page {
    padding: 10px;

    .head {
      flex-direction: column;
      align-items: flex-start;

      .pointer {
        margin-bottom: 10px;

        .el-button {
          padding: 7px 12px;
          font-size: 12px;
        }
      }

      .searchcontain {
        width: 100%;

        .searchInput {
          width: 100% !important;
        }
      }
    }

    .main {
      .goods_list {
        .goods_item {
          flex-direction: column;
          margin-top: 15px;
          padding-bottom: 15px;

          .goods_info {
            width: 100%;
            flex-direction: column;

            .elimage {
              width: 100%;
              min-width: auto;
              height: 200px;
              border-radius: 5px;
            }

            .elinfo {
              width: 100%;
              padding-left: 0;
              padding-top: 10px;

              .info-cont--top {
                .top-info--box {
                  flex-wrap: wrap;

                  .title {
                    font-size: 15px;
                    max-width: 100%;
                  }

                  .status-box {
                    margin-left: 0;
                    margin-top: 6px;
                    font-size: 12px;
                    width: 50px;
                    height: 22px;
                  }
                }

                .tag_box {
                  margin-top: 8px;

                  .category_name {
                    width: auto;
                    padding: 4px 8px;
                    font-size: 11px;
                  }
                }
              }

              .text {
                font-size: 12px;
                margin-top: 8px;

                .info-reason {
                  font-size: 13px;
                }
              }
            }
          }

          .goods_handle {
            width: 100%;
            text-align: left;
            margin-top: 8px;

            .status {
              justify-content: flex-start;

              .txt {
                font-size: 14px;
              }

              .dot {
                margin-right: 6px;
              }
            }
          }
        }
      }

      .el-empty--cont {
        min-height: 200px;
      }
    }

    .elpagination {
      // flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .elpagination-title {
        margin-bottom: 10px;
      }
    }

    .content-box {
      overflow-x: auto;

      .elpagination {
        flex-direction: column;
        align-items: flex-start;

        .elpagination-title {
          margin-bottom: 10px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>